import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_commuting_injuries_incl_fatalities_last_12_months'

export const dataPointDefinition = {
  retracedId: 'number_commuting_injuries_incl_fatalities_last_12_months',
  name: 'Number of commuting injuries (incl. fatalities) in the last 12 months:',
  description: 'Include both minor and serious injuries and fatalities that occurred during travel to and from work.',
  meta: {
    slcpMeta: {
      key: 'hs-fir-20',
      number: 'HS-FIR-16',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-fir-20', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31010,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
